module.exports = __webpack_public_path__ + "c4ce482d6b502e6ec4d9d080c8038ad8.png";